/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const preventFromSubmitOnEnter = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};
